import React from 'react';
import Head from 'next/head';
import dynamic from 'next/dynamic';
import BaseLayout from 'layouts/BaseLayout';
import MainContent from 'components/Anniversary/MainContent';
import { isAnniversaryActive } from 'utils';
import useIsMobile from 'hooks/useIsMobile';
import { COLOR_PURPLE_HOVER, COLOR_WHITE } from 'styles/variables/colors';

const CountdownBanner = dynamic(() => import('components/Anniversary/CountDownBanner'), {
  ssr: false,
});

export default function AnniversaryPage() {
  const isMobile = useIsMobile();

  return (
    <BaseLayout
      bgBrandColor={!isMobile ? COLOR_WHITE : COLOR_PURPLE_HOVER}
      headerWhite={true}
      typeBtn="buttonSecondary"
      hasPadding={false}
    >
      <Head>
        <title>Mind the Graph's 11th Anniversary: Transforming Research into Visual Impact</title>
        <meta
          key="title"
          name="title"
          content="Mind the Graph's 11th Anniversary: Transforming Research into Visual Impact"
        />
        <meta
          key="description"
          name="description"
          content="Mind the Graph (MTG) is celebrating 11 years of excellence in scientific illustrations and research visualization. Join us as we continue to bring research to life in the form of visualization."
        />
      </Head>

      {isAnniversaryActive() ? <CountdownBanner /> : null}

      <MainContent />
    </BaseLayout>
  );
}
